import { createSlice } from "@reduxjs/toolkit";
import { sortingList } from "../../helpers";

 
const productSlice = createSlice({
  name: "product",
  initialState: {
    createProduct: {},
    allProduct: [],
    productUpdate: {},
    isLoading: false, // Add isLoading property to the initial state
    grid_view: true,
    sort: "",
  },

  reducers: {
    // for create New products

    addNewProductRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    addNewProductSuccess: (state, action) => {
      state.createProduct = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    addNewProductFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },

    // for Get all products
    getProductsRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    getProductsSuccess: (state, action) => {
      state.allProduct = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    getProductsFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },

    // grid_view
    get_gridView_Success: (state, action) => {
      state.grid_view = action.payload;
    },

    // list_View
    get_listView_Success: (state, action) => {
      state.grid_view = action.payload;
    },
    // list_View
    get_sort_Success: (state, action) => {
      let tempProduct = {...state?.allProduct}; // Extract sort from action.payload
      const sort = state.sort; // Extract sort from action.payload
      const listData  =  sortingList(sort, tempProduct?.data)
      state.allProduct = { ...tempProduct, data: listData }
      state.sort = action.payload;
    },

    set_sort_Success: (state, action) => {
      state.sort = action.payload;
    },

    //  for product get by id
    getProductByIdRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    getProductByIdSuccess: (state, action) => {
      state.getProductById = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    getProductByIdFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },
    //  for product get by id

    deleteProductRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    deleteProductSuccess: (state, action) => {
      state.getProductById = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    deleteProductFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },

    // product visibility on switcher

    productVisibilityRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    productVisibilitySuccess: (state, action) => {
      state.productVisible = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    productVisibilityFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },

    // product Update

    productUpdateRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    productUpdateSuccess: (state, action) => {
      state.productUpdate = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    productUpdateFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },
  },
});

export const {
  addNewProductRequest,
  addNewProductSuccess,
  addNewProductFailure,
  getProductsRequest,
  getProductsSuccess,
  getProductsFailure,
  getProductByIdRequest,
  getProductByIdSuccess,
  getProductByIdFailure,
  deleteProductRequest,
  deleteProductSuccess,
  deleteProductFailure,
  productVisibilityRequest,
  productVisibilitySuccess,
  productVisibilityFailure,
  productUpdateRequest,
  productUpdateSuccess,
  productUpdateFailure,
  get_gridView_Success,
  get_listView_Success,
  get_sort_Success,
  get_sorting_Success,
  set_sort_Success,
} = productSlice.actions;

export default productSlice.reducer;
